export default {
  angleInRadians(angleInDegrees) {
    return (Number(angleInDegrees) - 90.0) * Math.PI / 180.0;
  },

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    let angleInRadians = this.angleInRadians(- angleInDegrees);

    return {
      x: Number(centerX) + (Number(radius) * Math.cos(angleInRadians)),
      y: Number(centerY) + (Number(radius) * Math.sin(angleInRadians))
    };
  }
}